/**
 * Foundation · Durate — indicatore discreto del formato attivo (a destra dell'etichetta)
 * e etichetta standard dei campi durata.
 */
import React from "react";
import { Clock } from "lucide-react";
import { Label } from "@/components/ui/label";
import { DURATION_FORMAT_BADGE } from "./durationCore";
import { useDurationFormat } from "./DurationFormatContext";

export function DurationFormatBadge({ "data-testid": testid = "duration-format-badge" }) {
  const fmt = useDurationFormat();
  return (
    <span
      className="inline-flex items-center gap-1 rounded border border-suite-neutral-200 bg-suite-neutral-50 px-1.5 py-px font-mono text-[10px] font-medium text-suite-neutral-500 select-none"
      title={fmt === "hm" ? "Durate in ore e minuti" : "Durate in ore centesimali"}
      aria-label={fmt === "hm" ? "Formato ore e minuti" : "Formato ore centesimali"}
      data-testid={testid} data-format={fmt}
    >
      {fmt === "hm" && <Clock size={10} aria-hidden="true" />}{DURATION_FORMAT_BADGE[fmt]}
    </span>
  );
}

export function DurationLabel({ htmlFor, children, className = "", "data-testid": testid }) {
  return (
    <div className={`flex items-center justify-between gap-2 ${className}`}>
      <Label htmlFor={htmlFor} className={className}>{children}</Label>
      <DurationFormatBadge data-testid={testid ? `${testid}-format-badge` : undefined} />
    </div>
  );
}
